export default __webpack_public_path__ + "static/media/joint-chairman.32f0a91e.jpg";